/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/LineageTracking
 * @desc ProtocolValue LineageTracking
 */

import { EntityActionUpdateCheckbox } from 'labstep-web/components/Entity/Action/Update/Checkbox';
import type React from 'react';
import type { IProtocolValueFormShowEditLineageTrackingProps } from './types';

export const ProtocolValueFormShowEditLineageTracking: React.FC<
  IProtocolValueFormShowEditLineageTrackingProps
> = ({ protocolValue }) => (
  <EntityActionUpdateCheckbox
    dataCy="components/ProtocolValue/Form/ShowEdit/LineageTracking"
    entity={protocolValue}
    field={'is_lineage' as const}
    toggle
  />
);
